export default "__VITE_ASSET__244879d0__"